import * as React from "react";
import {
  PostLikeFeatureButton,
  QuestionLikeFeatureButton,
} from "@vingle/wtf-sdk/components/featureButtons";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import NumberFormatter from "@vingle/wtf-sdk/components/numberFormatter";
import { LottieLikeEffect } from "common/components/lottieLikeControl";
import { ActionCreators as DialogActionCreators } from "app/vingleDialog/actions";
import OverlayTooltip from "common/components/overlayTooltip";
import { FormattedMessage } from "react-intl";

const styles = require("./outlineLikeEngageButton.scss");

export interface IProps {
  likedState: boolean;
  likeCount: number;
  width: number;
  height: number;
  postId?: Vingle.Id;
  questionId?: string;
  onClick?: () => void;
}

interface IState {
  isInHover: boolean;
}

class OutlineLikeEngageButton extends React.PureComponent<IProps, IState> {
  public state: IState = {
    isInHover: false,
  };

  public render() {
    const {
      questionId,
      postId,
      width,
      height,
      likedState,
      onClick,
    } = this.props;

    let targetFeatureButton;
    if (questionId) {
      targetFeatureButton = (
        <QuestionLikeFeatureButton
          questionId={questionId}
          likedState={likedState}
          unsignedUserAction={DialogActionCreators.openSignUpDialog}
          className={styles.wrapper}
          style={{
            width,
            height,
          }}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onClick={onClick}
        >
          {this.renderInner()}
        </QuestionLikeFeatureButton>
      );
    } else if (postId) {
      targetFeatureButton = (
        <PostLikeFeatureButton
          postId={postId}
          likedState={likedState}
          unsignedUserAction={DialogActionCreators.openSignUpDialog}
          className={styles.wrapper}
          style={{
            width,
            height,
          }}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onClick={onClick}
        >
          {this.renderInner()}
        </PostLikeFeatureButton>
      );
    } else {
      return null;
    }

    return (
      <OverlayTooltip
        position="right"
        tooltipContent={<FormattedMessage tagName="span" id="like" />}
      >
        {targetFeatureButton}
      </OverlayTooltip>
    );
  }

  private readonly renderInner = () => {
    const { likeCount, likedState } = this.props;
    const { isInHover } = this.state;
    const baseIcon = likedState
      ? PACKS.ENGAGE.LIKE_ACTIVE
      : PACKS.ENGAGE.LIKE_NORMAL;
    const changeableIcon = isInHover ? PACKS.ENGAGE.LIKE_HOVER : baseIcon;

    return (
      <>
        <span className={styles.likeIconWrapper}>
          <IconWrapper
            tagName="span"
            icon={changeableIcon}
            className={styles.icon}
          />
          <span className={styles.likeLottie}>
            <LottieLikeEffect liked={likedState} likeCount={likeCount} />
          </span>
        </span>

        {Boolean(likeCount) && (
          <span className={styles.engageCount}>
            <NumberFormatter num={likeCount} digits={0} />
          </span>
        )}
      </>
    );
  };

  private readonly changeIsInHoverState = (state: boolean) => {
    if (this.state.isInHover !== state) {
      this.setState({
        isInHover: state,
      });
    }
  };

  private readonly handleMouseEnter = () => {
    this.changeIsInHoverState(true);
  };

  private readonly handleMouseLeave = () => {
    this.changeIsInHoverState(false);
  };
}

export default OutlineLikeEngageButton;
